export default __webpack_public_path__ + "static/media/cloud-computing.52a61301.svg";